import axiosInstance from "../../api/axiosConfig";
import { getApiBaseUrl } from "../../baseUrl";
import { Empresa } from "../../../types/empresa/empresa";

export async function buscarEmpresaPorId(
  empresaId: string,
): Promise<Empresa | null> {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await axiosInstance.get(`${apiUrl}/empresas/${empresaId}`);
    return response.data || null;
  } catch (error) {
    console.error("Erro ao buscar empresa por ID:", error);
    return null;
  }
}

export async function buscarEmpresas(): Promise<Empresa[]> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.get(`${apiUrl}/empresas`);
  // Garantir que sempre retorna um array
  if (Array.isArray(response.data)) {
    return response.data;
  } else if (response.data && typeof response.data === "object") {
    // Se for um objeto com propriedade content ou data (comum em paginação)
    if (response.data.content && Array.isArray(response.data.content)) {
      return response.data.content;
    } else if (response.data.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
  }
  console.warn("Resposta inesperada da API de empresas:", response.data);
  return [];
}

export function getImagemEmpresaUrl(empresaId: number): string {
  const apiUrl = getApiBaseUrl();
  return `${apiUrl}/empresas/${empresaId}/imagem`;
}

export async function atualizarImagemEmpresa(
  empresaId: number,
  imagemBase64: string,
): Promise<any> {
  const apiUrl = getApiBaseUrl();

  // Converter Base64 para bytes
  // Remover o prefixo "data:image/...;base64," se existir
  let base64String = imagemBase64;
  if (base64String.startsWith("data:")) {
    base64String = base64String.substring(base64String.indexOf(",") + 1);
  }

  // Decodificar Base64 para bytes
  const binaryString = window.atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const response = await axiosInstance.put(
    `${apiUrl}/empresas/${empresaId}/imagem`,
    bytes,
    {
      headers: {
        "Content-Type": "application/octet-stream",
      },
    }
  );
  return response.data;
}

export async function uploadImagemEmpresa(
  empresaId: number,
  formData: FormData,
): Promise<{ url: string }> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.post(
    `${apiUrl}/empresas/${empresaId}/upload-imagem`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
}

export async function atualizarEmpresa(
  empresaId: number,
  dadosEmpresa: Partial<Empresa>,
): Promise<Empresa> {
  const apiUrl = getApiBaseUrl();
  const response = await axiosInstance.put(
    `${apiUrl}/empresas/${empresaId}`,
    dadosEmpresa,
  );
  return response.data;
}

export async function alterarSenhaEmpresa(
  empresaId: number,
  senhaData: { senhaAtual: string; novaSenha: string },
): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 1000));
}

export async function alterarEmailEmpresa(
  empresaId: number,
  emailData: { novoEmail: string },
): Promise<Empresa> {
  await new Promise((resolve) => setTimeout(resolve, 1000));

  return {
    id: empresaId,
    email: emailData.novoEmail,
  } as Empresa;
}

export interface RecuperarSenhaEmpresaResponse {
  success: boolean;
  message: string;
}

export async function recuperarSenhaEmpresa(email: string): Promise<RecuperarSenhaEmpresaResponse> {
  const apiUrl = getApiBaseUrl();

  try {
    const response = await axiosInstance.post(`${apiUrl}/empresas/recuperar-senha`, { email });

    return {
      success: response.data.success || true,
      message: response.data.message || 'Nova senha enviada para o email cadastrado'
    };
  } catch (error: any) {
    console.error('Erro ao recuperar senha:', error);

    if (error.response?.data?.message) {
      return {
        success: false,
        message: error.response.data.message
      };
    }

    return {
      success: false,
      message: 'Erro ao processar recuperação de senha'
    };
  }
}
